module.exports = __webpack_public_path__ + "img/document_01.ef7826dd.png";